module.exports = "<p>\r\n  about works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/about/about.component.html
// module id = ./src/app/components/about/about.component.html
// module chunks = main